<template>
  <div class="accordion-section">
    <IonAccordionGroup>
      <IonAccordion :value="value" :toggle-icon="chevronDownOutline" toggle-icon-slot="end">
        <IonItem slot="header" color="dark">
          <IonIcon v-if="icon" :icon="icon" slot="start" class="header-icon"></IonIcon>
          <IonLabel>
            <h3 class="accordion-title">{{ title }}</h3>
          </IonLabel>
          <IonBadge v-if="badgeCount !== undefined" color="primary">{{ badgeCount }}</IonBadge>
        </IonItem>
        <div slot="content" class="accordion-content">
          <slot></slot>
        </div>
      </IonAccordion>
    </IonAccordionGroup>
  </div>
</template>

<script setup lang="ts">
import { IonAccordionGroup, IonAccordion, IonItem, IonLabel, IonBadge, IonIcon } from '@ionic/vue';
import { chevronDownOutline } from 'ionicons/icons';

defineProps<{
  title: string;
  value: string;
  icon?: string;
  badgeCount?: number;
}>();
</script>

<style scoped>
.accordion-section {
  margin-top: 24px;
}

ion-accordion {
  background: transparent;
}

ion-accordion::part(icon) {
  color: var(--ion-color-primary);
  font-size: 20px;
}

ion-item::part(native) {
  border-radius: 8px;
  background-color: var(--ion-background-color);
  border: 1px solid var(--ion-input-border-color);
}

ion-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: 20px;
  padding: 0 6px;
  background-color: var(--ion-background-color);
  border: 1px solid var(--ion-input-border-color);
}

.header-icon {
  color: var(--ion-color-primary);
  margin-right: 8px;
}

.accordion-title {
  font-weight: 600;
  color: var(--ion-color-primary);
  margin: 0;
}

.accordion-content {
  padding: 16px;
  background-color: var(--ion-background-color);
}
</style>
